module.exports = __webpack_public_path__ + "img/3-4.ef109f54.png";